import BASIC from "./basic";

export default {
  ...BASIC,
  background: '#282c34',
  color: '#fff',
};
